module.exports = __webpack_public_path__ + "img/152.26cc8515.png";